
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({})
export default class SingularityBadge extends Vue {
  @Prop({ required: true })
  value!: string;

  @Prop({ default: "default" })
  color!: "default" | "teal";
}
